// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_property-record_property-record_module_ts":"c04a44671dc4eb28","node_modules_apexcharts_dist_apexcharts_esm_js":"bc8d64943e7b1c56","node_modules_apexcharts_dist_core_esm_js":"9f91ff8a36e1ef97","node_modules_apexcharts_dist_apexcharts_ssr_esm_js":"a5efd8340143f3ad"}[chunkId] + ".js";
};